import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RelativeDate } from '../pipes/relative-date';
import { StrLimit } from '../pipes/str-limit';
import { UlinkyPipe } from '../pipes/ulinky';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { BgImgDirective } from './directives/bg-img/bg-img.directive';
import { ClipboardDirective } from './directives/clipboard/clipboard.directive';
import { SlideUpDirective } from '../directives/slide-up.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
  ],
  declarations: [
    RelativeDate,
    StrLimit,
    UlinkyPipe,
    CapitalizePipe,
    BgImgDirective,
    ClipboardDirective,
    SlideUpDirective,
  ],
  exports: [
    FormsModule,
    RelativeDate,
    StrLimit,
    UlinkyPipe,
    CapitalizePipe,
    BgImgDirective,
    ClipboardDirective,
    SlideUpDirective,
  ],
})
class SharedModule {}

export { SharedModule };
